module.exports = __webpack_public_path__ + "img/logo.2421723a.png";